import React from "react";
import "../components/MacWindow.css";
import Draggable from "react-draggable";
import profile from "../images/profile.png";
import { IoLogoLinkedin, IoLogoGithub } from "react-icons/io5";
import {
  SiLeetcode,
  SiHackerrank,
  SiHashnode,
  SiGeeksforgeeks,
  SiCodechef,
} from "react-icons/si";

export default function Settings({ onClose }) {
  const onMaximize = () => {
    window = document.querySelector(".window");
    // window.maximize();
  };
  const onMinimize = () => {};
  return (
    <Draggable handle=".windowheader">
      <div className="draggable-container">
        <div class="window">
          <div class="windowheader">
            <div class="wrapper">
              <div class="nav-buttons">
                <div class="close" onClick={onClose}></div>
                <div class="minimize" onClick={onMinimize}></div>
                <div class="expand" onClick={onMaximize}></div>
              </div>
              <div class="title">Settings</div>
            </div>
          </div>

          <div class="body">
            <div className="grid">
              <div className="profile">
                <img src={profile} alt="Profile-pic" className="profile-pic" />
              </div>
              <div className="intro">
                <h2>RoopaOS, version 1.0.0</h2>
                <p>
                  Welcome to RoopaOS! Here, you can find all the details about
                  Roopa.
                </p>
                <div className="socials">
                  <a href="https://shorturl.at/UBAQy" target="_blank">
                    <IoLogoLinkedin className="social-icons" />
                  </a>
                  <a href="https://shorturl.at/rVGw3" target="_blank">
                    <IoLogoGithub className="social-icons" />
                  </a>
                  <a href="https://shorturl.at/HKTzb" target="_blank">
                    <SiLeetcode className="social-icons" />
                  </a>
                  <a href="https://shorturl.at/NBbcN" target="_blank">
                    <SiHackerrank className="social-icons" />
                  </a>
                  <a href="https://shorturl.at/01sYg" target="_blank">
                    <SiGeeksforgeeks className="social-icons" />
                  </a>
                  <a href="https://rb.gy/2pppq5" target="_blank">
                    <SiHashnode className="social-icons" />
                  </a>
                  <a href="https://rb.gy/mhf57q" target="_blank">
                    <SiCodechef className="social-icons" />
                  </a>
                  <a
                    href="https://t.ly/Y_evg"
                    className="resume"
                    target="_blank"
                  >
                    <button>Resume</button>
                  </a>
                </div>
              </div>
            </div>

            <div className="copyright">
              <p>Developed by Rupa-Rd©️</p>
            </div>
          </div>
          {/* <footer>
        <p>Developed by Rd</p>
    </footer> */}
        </div>
      </div>
    </Draggable>
  );
}
